module.exports = __webpack_public_path__ + "static/img/record2.60679ac.gif";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/record2.gif
// module id = 60ZJ
// module chunks = 1